// @flow

import { stringify } from 'query-string';
import type {
  Links,
} from '../../../types/pdb';
import getEntries from '../../../helpers/getEntries';
import { getIsActive as getVbmrIsActive } from '../../configuration/vbmr/selectors';
import { getPdbItem } from './main';

const addQueryData = (link, queryData): string => {
  if (link === '' || link === null) {
    return '';
  }

  const uri = stringify(getEntries(queryData)
    .reduce((acc, [key, value]) => {
      if (value) {
        return {
          ...acc,
          [key]: value,
        };
      }
      return acc;
    }, {}));
  if (!link.includes(uri)) {
    return `${link}?${uri}`;
  }
  return link;
};

export const getLinks = (state: any, pdbId: ?string = null): Links => {
  const pdbItem = getPdbItem(state, pdbId);
  return pdbItem.links;
};

export const getConfirmationLink = (state: any, pdbId: ?string = null): ?string => {
  const links = getLinks(state, pdbId);
  return links.confirm;
};

export const getConfigLink = (
  state: any,
  pdbId: ?string = null,
  queryData?: Object = {},
): string => {
  const links = getLinks(state, pdbId);
  return addQueryData(links.config, queryData);
};

export const getVbmrConfigLink = (
  state: any,
  pdbId: ?string = null,
  queryData?: Object = {},
): string => getConfigLink(
  state,
  pdbId,
  getVbmrIsActive(state) ? { vbmr: 1 } : queryData,
);

export const getInfoLink = (
  state: any,
  pdbId: ?string = null,
  queryData: Object = {},
): string => {
  const links = getLinks(state, pdbId);
  return addQueryData(links.info, queryData);
};

export const getOrderLink = (state: any, pdbId: ?string = null): string => {
  const links = getLinks(state, pdbId);
  return links.order;
};
